import React from 'react'
import { useEffect, useRef, useState } from "react";
import { Box, Modal,Button } from "@mui/material";
import axios from "axios";
import toastr from "toastr";

import {BtnSecondary, BtnPrimary } from "../components/buttons";

const ApprovalModal = (props) => {

    const [cnfModal, setCnfModal] = useState(false);
    const [invoiceId, setInvoiceId] = useState(props.invoiceid?props.invoiceid:"");
    const [transactionid, setTransactionid] = useState(props.transactionid?props.transactionid:"");
    const [subscriptionId, setSubscriptionId] = useState(props.subscriptionId?props.subscriptionId:"");
     // send invoice function  start from here
     const style = {
   
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 420,
      bgcolor: "background.paper",
      border: "none",
      boxShadow: 24,
      p: "35px 10px 30px 30px",
    };
   
    const handleClose = () => {
      setCnfModal(false);      
    };
  
    const sendInvoiceFunc = async() =>{
        console.log(invoiceId,transactionid,subscriptionId,"buttonsbuttonsbuttonsbuttonsbuttonsbuttonsbuttons")
      if(invoiceId){
          setCnfModal(true);   
          setInvoiceId(invoiceId)
      }
      if(transactionid){
          setCnfModal(true);   
          setTransactionid(transactionid)
      }
      if(subscriptionId){
          setCnfModal(true);   
          setSubscriptionId(subscriptionId)
      }
     
  }
  
  const handleApproval = async() => {
    try {
       
        const response = await axios.post(`${props.invoiceSendApi}`,{id:invoiceId,transactionid:transactionid,subscriptionId:subscriptionId})
          console.log(response,"responseresponse")
  
        if(response.status==200){
            toastr.success(response.data.message)
            setCnfModal(false);    
        setInvoiceId("")
        setTransactionid("")
    }
        if(response.status==404){
            toastr.warning(response.data.message)
            setCnfModal(false);    
        setInvoiceId("")
        setTransactionid("")
    }
      } catch (error) {
      
        toastr.warning("No data found!")
        setCnfModal(false);    
    setInvoiceId("")
    setTransactionid("")
      }
   };

   const giveAccessModalFunc = async() =>{
    console.log(props.entry,"props.entryprops.entry")
      if(props.entry){
          setCnfModal(true);   
       
      }
      
    }
    
      
       const giveAccess = async () =>{
        try {
                
            let items = props.entry 
            // console.log(items,"responseresponseresponse") 
            // return
        const response = await axios.post(`${props.giveaccessapi}`,{...items})
      
        if(response.status=="200"){
            toastr.success(response.data.message)
            setCnfModal(false);
    }else{
        toastr.error(response.data.message)
        setCnfModal(false);    
    }
      } catch (error) {
        
        toastr.error(error.response.data.message)
        setCnfModal(false);    
      }
    }
  
  return (
   <>
     {props.showInvoicBtn && <BtnPrimary action={() =>sendInvoiceFunc()}>Send Invoice</BtnPrimary>}
   { props.showGiveAccess &&<BtnSecondary action={() =>giveAccessModalFunc()}>Give Access</BtnSecondary>}



                                      <Modal
                  open={cnfModal}
                  onClose={handleClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  >
                  <Box sx={style}>
                 
                
                  <p className="approvalTestModal">{`${props.showGiveAccess ?"Are you sure you want to give access to enroll in the course?":"Are you sure you want to proceed for sent Invoice"}`}</p>
                
                      <div className="approvalBtn">
                      {props.showInvoicBtn &&<Button className="approvalYES" onClick={handleApproval}>Yes</Button>}
                     { props.showGiveAccess &&<Button className="approvalYES" onClick={giveAccess}>Yes</Button>}
                          <Button className="approvalNO"onClick={handleClose} autoFocus>
                              No
                          </Button>
                      </div>
                  </Box>
                  </Modal>
   </>

  )
}

export default ApprovalModal